



















import {Component, Prop, Watch, Vue} from "vue-property-decorator";
import Guess, {GuessDigit} from "@/classes/Guess.ts";
import DigitGuessState from "@/components/Game/DigitGuessState.vue";
import Config from "@/classes/Config.ts";

@Component({
    components: {
        DigitGuessState
    }
})
export default class DigitGuessModule extends Vue {
    @Prop() public props!: Guess;
    @Prop() public remainingAttempts!: number;
    protected digits: GuessDigit[] = [];
    protected id: number = 0;
    protected zIndex: number = -Config.TOTAL_ATTEMPTS;
    protected step: number = 0;

    public created() {
        this.digits = this.props.digits;
        this.id = this.props.id;
        this.zIndex = -this.props.id - 1;
    }

    @Watch("remainingAttempts")
    protected updateStep(): void {
        this.step = Config.TOTAL_ATTEMPTS - this.remainingAttempts - this.id - 1;
    }
}
